import React from 'react';
import './Alert.css';

/**
 * Alert
 * @param {string} variant - 'info' | 'warning' | 'success' | 'error'
 */
export default function Alert({ children, variant = 'info' }) {
  return <div className={`alert alert--${variant}`}>{children}</div>;
}
